import { createContext, useContext } from 'react';

/**
 * Single shared context for the analysis object. All dashboard components
 * read schedule data through this context — no prop drilling, no Redux.
 *
 * Value shape:
 *   { analysis, reportId, status: 'loading' | 'ready' | 'error', error: string | null }
 */
const AnalysisContext = createContext({
  analysis: null,
  reportId: null,
  status: 'loading',
  error: null,
});

export function AnalysisProvider({ value, children }) {
  return <AnalysisContext.Provider value={value}>{children}</AnalysisContext.Provider>;
}

export function useAnalysis() {
  return useContext(AnalysisContext);
}
